import React from 'react';
import PropTypes from 'prop-types';
import Modal from "react-modal";
import IconImage, {Icons} from "./IconImage";

const BulkAssignStoresModal = ({isOpen, onClose = () => {}, children}) => {
    return <Modal
        clickable
        isOpen={isOpen}
        className={"bulk-assign-stores-modal"}
        overlayClassName="Overlay"
        ariaHideApp={false}
        onRequestClose={onClose}
    >
        <div data-testid={'bulk-assign-stores-modal'}>
            <div className={'modal-header'}>
                <h1>Bulk Assign Stores by File Import</h1>
                <button type={'button'} aria-label={'close'} onClick={onClose}>
                    <IconImage iconType={Icons.CLOSE}/>
                </button>
            </div>
            <div className={'modal-body'}>{children}</div>
        </div>
    </Modal>

};

BulkAssignStoresModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func
};

export default BulkAssignStoresModal;